import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {EodDistributorComponent} from "./eod-distributor.component";


const routes: Routes = [
  {
    path: '',
    component: EodDistributorComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EodDistributorRoutingModule { }
